var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    transform: "translate(9.000000, 8.999987) rotate(180.000000) translate(-9.000000, -8.999987) ",
    fill: "#323232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7071,1.7071 C10.0976,1.31658 10.0976,0.68342 9.7071,0.29289 C9.3166,-0.09763 8.6834,-0.09763 8.2929,0.29289 L0.29385,8.2919 C0.29136,8.2944 0.28887,8.2969 0.2864,8.2994 C0.10925,8.4799 0,8.7272 0,9 C0,9.1367 0.02742,9.2669 0.07705,9.3856 C0.12472,9.4998 0.1945,9.607 0.2864,9.7005 C0.28883,9.703 0.29127,9.7055 0.29372,9.7079 L8.2929,17.7071 C8.6834,18.0976 9.3166,18.0976 9.7071,17.7071 C10.0976,17.3166 10.0976,16.6834 9.7071,16.2929 L3.41421,10 L17,10 C17.5523,10 18,9.5523 18,9 C18,8.4477 17.5523,8 17,8 L3.41422,8 L9.7071,1.7071 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6cbe51a6c73bc56dc355c373949f59c4.svg";
export { ForwardRef as ReactComponent };